<div class="page-header" (click)="$event.stopPropagation()">
  <div class="left">
    <a
      (click)="goToRoot()"
      [ngStyle]="{ cursor: isRoot ? 'default' : 'pointer' }"
    >
      <img src="assets/inwedio-logo.svg" alt="Inwedio" class="logo" />
    </a>
    <!-- Organisation selector (hidden on quest route) -->

    <ng-container *ngIf="currentOrgNoCurrentProject$ | async">
      <div
        class="org-select"
        #orgTrigger
        (click)="toggleOrgDropdown()"
        *ngIf="!isQuestRoute"
      >
        <span class="org-name">
          {{ (currentOrg$ | async)?.name || 'Select organisation' }}
        </span>
        <!-- <ng-template #selectOrg>Select organisation</ng-template> -->
        <!-- <span class="arrow" aria-hidden="true">▾</span> -->
      </div>
    </ng-container>

    <!-- Project name + settings -->
    <div class="project-wrap" *ngIf="currentProjectID$ | async">
      <!-- <div>
        <nw-icon type="arrow_back_ios"></nw-icon>
      </div> -->
      <div class="project-name">
        <ng-container *ngIf="projectLabel$ | async as pname">
          <span *ngIf="!editingProject" (click)="startEditProjectName(pname)">{{
            pname
          }}</span>
          <!-- <span class="arrow" aria-hidden="true">▾</span> -->

          <input
            #projectNameInput
            *ngIf="editingProject"
            [(ngModel)]="editedProjectName"
            (blur)="commitProjectName()"
            (keydown.enter)="commitProjectName()"
            (keydown.escape)="cancelEditProjectName()"
            class="project-input"
          />
        </ng-container>
      </div>
      <div style="position: relative; top: 1px; margin-left: 4px">
        <nw-icon
          #projectSettingsTrigger
          (click)="toggleProjectSettings()"
          type="settings"
          [size]="17"
          [outlined]="true"
        >
        </nw-icon>
      </div>

      <div
        class="project-settings-popup"
        #projectSettingsPopup
        *ngIf="showProjectSettings"
      >
        <div class="row">
          <label>Font family</label>
          <nw-font-family-selector
            [fontFamily]="projectFontFamily"
            [emitOnly]="true"
            (fontSelected)="onProjectFontSelected($event)"
          ></nw-font-family-selector>
        </div>
        <div class="row">
          <label>Color palette</label>
          <div class="palette-list">
            <div
              class="palette-row"
              *ngFor="let row of projectPaletteRows; let i = index"
            >
              <input class="name" [(ngModel)]="row.name" placeholder="name" />
              <input
                class="color"
                [(ngModel)]="row.color"
                placeholder="#RRGGBB"
              />
              <button
                class="remove"
                (click)="removePaletteRow(i)"
                type="button"
              >
                ✕
              </button>
            </div>
            <button class="add" (click)="addPaletteRow()" type="button">
              + Add color
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Organisation dropdown (hidden on quest route) -->
    <div
      class="org-dropdown"
      #orgDropdown
      *ngIf="showOrgDropdown && !isQuestRoute"
    >
      <div class="org-dropdown-list">
        <div
          class="org-item"
          *ngFor="let o of orgs$ | async"
          (click)="onSelectOrg(o.id)"
        >
          <div class="org-item-name">{{ o.name }}</div>
          <div class="org-item-role" *ngIf="myUserId$ | async as uid">
            <span *ngIf="o.roles?.[uid]?.type as role">[{{ role }}]</span>
          </div>
        </div>
        <div class="empty" *ngIf="(orgs$ | async)?.length === 0">
          No organisations
        </div>
      </div>
    </div>
  </div>
  <!-- User info (hidden on quest route) -->
  <div class="right" *ngIf="myUser$ | async as me; else questRight">
    <div
      class="user-menu"
      #avatarTrigger
      (click)="toggleUserDropdown(); $event.stopPropagation()"
    >
      <div class="avatar">
        {{ getAvatarName(me) }}
      </div>
      <div class="name">{{ getUserName(me) }}</div>
      <nw-icon type="expand_more" [size]="16"></nw-icon>
    </div>

    <!-- User dropdown -->
    <div class="user-dropdown" #userDropdown *ngIf="showUserDropdown">
      <div class="user-dropdown-item" (click)="signOut()">
        <nw-icon type="logout" [size]="18"></nw-icon>
        <span>Sign out</span>
      </div>
    </div>
  </div>
  <ng-template #questRight>
    <div class="right" *ngIf="isQuestRoute"></div>
  </ng-template>
</div>
